// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Rgv3","content":"styles_content__11kda","tableWrap":"styles_tableWrap__3XQXH"};